import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { peekPdfTab, releasePdfTab } from 'app/shared/utils/common.util';
import { finalize, map } from 'rxjs';

/**
 * ERP Bug 353: the BE names each generated PDF (Content-Disposition, e.g. Quotation_JMS-26-0049428.pdf).
 * Blob bodies lose headers, so hand the body on as a File carrying that name; downloadPdfBlob uses it.
 * ERP Bug 464: a tab reserved for this request (reservePdfTab) closes if its PDF never reaches downloadPdfBlob, e.g. the request failed.
 */
export const pdfFileNameInterceptor: HttpInterceptorFn = (req, next) => {
    const tab = req.responseType === 'blob' ? peekPdfTab() : null;
    let otherFile = false; // e.g. an Excel download that overlaps the preview: it must not close the PDF's tab
    const named = next(req).pipe(
        map((event) => {
            if (!(event instanceof HttpResponse) || !(event.body instanceof Blob)) return event;
            otherFile = !!event.body.type && !/pdf/i.test(event.body.type);
            const name = /filename="?([^";]+)"?/i.exec(event.headers.get('Content-Disposition') ?? '')?.[1];
            return name ? event.clone({ body: new File([event.body], name, { type: event.body.type }) }) : event;
        })
    );
    return tab
        ? named.pipe(
              finalize(() => {
                  if (!otherFile) releasePdfTab(tab);
              })
          )
        : named;
};
